// @ts-nocheck
import { Link, useParams, useLocation, useNavigate } from 'react-router-dom';
import {
  ArrowLeft,
  BarChart3,
  BookPlus,
  UserCircleIcon,
  Edit3,
  FileCode,
  FileText,
  Github,
  Globe,
  Layout,
  LayoutDashboard,
  Megaphone,
  Menu,
  Newspaper,
  Settings,
  Pencil,
  CreditCard,
  Settings2,
  Calendar,
  CalendarDays,
  Camera,
  Sparkles,
  LayoutGrid,
  MapPin,
  Trophy,
  Users,
  Receipt,
  Mail
} from "lucide-react";
import { Button } from "@/components/ui/button"
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandItem,
  CommandList,
  CommandSeparator,
} from "@/components/ui/command"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { cn } from "@/lib/utils"
import { Check, ChevronDown, ChevronRight, Plus, Search as SearchIcon } from "lucide-react"
import { Badge } from "@/components/ui/badge"
import { Separator } from "@/components/ui/separator"
// import {
//   useSelectedLayoutSegments,
// } from "next/navigation";
import { ReactNode, useEffect, useMemo, useState } from "react";
import { useUser, useAuth, useOrganizationList, useOrganization } from '@/auth/clerkShim';
import CreateLeagueModal from "@/components/CreateLeague/create-league-modal";
import { useOutletContext } from 'react-router-dom';
import Logo from "../../assets/icons/black_logo.png";
import _ from 'lodash';
import { getSportLabel } from '@staty/shared/utils/sportLabels';
import { getNavSections, OPEN_COMMAND_PALETTE_EVENT } from './navItems';
import './Nav.css';
// import { getSiteFromMenuId } from "@/lib/fetchers";
// import Image from "next/image";
// import { FileCode, Github } from "lucide-react";

// (The Vercel platforms-starter-kit `externalLinks` array that used to live
// here was dead code from the original template — removed.)

export default function Nav({ children, league }) {
  const { isSignedIn, user = {}, isLoaded } = useUser();
  const [memberships, setMemberships] = useState([]);
  const { setActive } = useOrganizationList();
  const { organization, isLoaded: isLoadedOrganization } = useOrganization();
  const navigate = useNavigate();
  const auth = useAuth();
  const location = useLocation();
  // const { leagueName } = useOutletContext();  
  let leagueName = auth.orgSlug || '';

  const pathname = location.pathname;
  const segments = pathname.split("/").filter((s) => s);
  // const segments = useSelectedLayoutSegments();
  const { id } = useParams();

  const [siteId, setSiteId] = useState();

  const role = _.get(user, 'organizationMemberships[0].role', 'org:member');

  useEffect(() => {
    if (isSignedIn) {
      async_getOrganizationMemberships();
    }
  }, [isSignedIn]);

  const async_getOrganizationMemberships = async () => {
    const memberships = await user.getOrganizationMemberships();
    setMemberships(memberships);
  }

  const onOrganizationChange = (e) => {
    const organizationId = e.target.value;
    setActive({ organization: organizationId });
    setTimeout(() => {
      window.location.href = '/admin/dashboard';
    }, 10);
  }

  const getAdminRole = () => {
    const membership = _.find(_.get(user, 'organizationMemberships', []), (membership) => membership.organization.id === organization.id);
    return _.get(membership, 'role', 'org:member');
  }

  const isAdmin = getAdminRole() === 'org:admin';

  // The /admin nav entries live in ONE registry shared with the ⌘K command
  // palette (navItems.tsx) — add new pages there, not here. This component
  // only adapts registry items to the legacy tab shape the render expects.
  const navSections = useMemo(
    () => _.keyBy(getNavSections({ league, leagueName }), 'key'),
    [league, leagueName]
  );
  const toTab = (item) => ({
    name: item.name,
    href: item.href,
    isActive: item.isActiveFn(segments),
    icon: <item.Icon width={18} />,
    newTab: item.newTab,
    dataTour: item.dataTour,
  });

  // Main navigation tabs - reorganized for better flow
  const mainTabs = useMemo(() => {
    if (segments[0] === "site" && id) {
      return [
        {
          name: "Back to All Sites",
          href: "/sites",
          icon: <ArrowLeft width={18} />,
        },
        {
          name: "Menus",
          href: `/site/${id}`,
          isActive: segments.length === 2,
          icon: <Newspaper width={18} />,
        },
        {
          name: "Analytics",
          href: `/site/${id}/analytics`,
          isActive: segments.includes("analytics"),
          icon: <BarChart3 width={18} />,
        },
        {
          name: "Settings",
          href: `/site/${id}/settings`,
          isActive: segments.includes("settings"),
          icon: <Settings width={18} />,
        },
      ];
    } else if (segments[0] === "menu" && id) {
      return [
        {
          name: "Back to All Menus",
          href: siteId ? `/site/${siteId}` : "/sites",
          icon: <ArrowLeft width={18} />,
        },
        {
          name: "Editor",
          href: `/menu/${id}`,
          isActive: segments.length === 2,
          icon: <Edit3 width={18} />,
        },
        {
          name: "Settings",
          href: `/menu/${id}/settings`,
          isActive: segments.includes("settings"),
          icon: <Settings2 width={18} />,
        },
      ];
    }

    // Default /admin navigation — sourced from the shared registry.
    return navSections.overview.items.map(toTab);
  }, [segments, id, siteId, navSections]);

  const leagueManagementTabs = navSections.leagueManagement.items.map(toTab);
  const registrationTabs = navSections.registration.items.map(toTab);
  const financialTabs = navSections.financial.items.map(toTab);
  const systemTabs = navSections.system.items.map(toTab);

  const [showSidebar, setShowSidebar] = useState(false);

  // State to track which sections are expanded
  const [expandedSections, setExpandedSections] = useState({
    overview: true,
    leagueManagement: true,
    registration: true,
    financial: true,
    system: true,
  });

  useEffect(() => {
    // hide sidebar on path change
    setShowSidebar(false);

    // Auto-expand sections that contain active links based on current path segments
    const hasActiveInMain = segments.includes("dashboard") || segments.length === 0;
    const hasActiveInLeague = segments.includes("tournaments") || segments.includes("tournament") ||
      segments.includes("seasons") || segments.includes("season") ||
      segments.includes("locations");
    const hasActiveInRegistration = segments.includes("registration") || segments.includes("members");
    // Activity Log moved from System & Tools into the payments section
    // (owner 2026-09-11).
    const hasActiveInFinancial = segments.includes("transactions") || segments.includes("logs");
    const hasActiveInSystem = segments.includes("editor") || segments.includes("waivers") ||
      segments.includes("settings");

    setExpandedSections(prev => ({
      overview: hasActiveInMain || prev.overview,
      leagueManagement: hasActiveInLeague || prev.leagueManagement,
      registration: hasActiveInRegistration || prev.registration,
      financial: hasActiveInFinancial || prev.financial,
      system: hasActiveInSystem || prev.system,
    }));
  }, []);

  const toggleSection = (sectionKey) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionKey]: !prev[sectionKey],
    }));
  };

  const MOBILE = 'lg';

  const leagueNameComponent = _.get(memberships, 'length') > 1 ? (
    <select className="bg-inherit" value={auth.orgId} onChange={onOrganizationChange}>
      {_.map(memberships, (membership) => (
        <option key={membership.organization.id} value={membership.organization.id}>{membership.organization.name}</option>
      ))}
    </select>
  ) : (
    <div className="py-2">{league?.displayName}</div>
  );

  const [open, setOpen] = useState(false);
  const selectedLeague = _.find(memberships, (membership) => membership.organization.id === auth.orgId)?.organization || { name: league?.displayName || 'Select League' };

  const leagueNameComponentNew = _.get(memberships, 'length') > 1 ? (
    <div className="inline-block w-full">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="ghost" role="combobox" aria-expanded={open} className="w-full pl-4 pr-2 justify-between h-12 bg-card hover:bg-muted/50 border border-border text-foreground shadow-sm">
            <div className="flex items-center text-base font-medium truncate">{selectedLeague.name}</div>
            <ChevronDown className="ml-2 h-4 w-4 shrink-0 opacity-70" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="p-0 w-64" align="start">
          <Command>
            <CommandList>
              <CommandEmpty>No league found.</CommandEmpty>
              <CommandGroup>
                {_.map(memberships, (membership) => (
                  <CommandItem
                    key={membership.organization.id}
                    value={membership.organization.id}
                    onSelect={() => {
                      onOrganizationChange({ target: { value: membership.organization.id } });
                      setOpen(false);
                    }}
                    className="flex items-center gap-2 cursor-pointer"
                  >
                    <span className="font-medium">{membership.organization.name}</span>
                    <Check
                      className={cn("ml-auto h-4 w-4", auth.orgId === membership.organization.id ? "opacity-100" : "opacity-0")}
                    />
                  </CommandItem>
                ))}
              </CommandGroup>
              <CommandSeparator />
              {isAdmin && (
                <CommandGroup>
                  <CommandItem
                    onSelect={() => {
                      console.log("Create new league")
                    }}
                    className="flex items-center gap-2 text-muted-foreground cursor-pointer"
                  >
                    <Plus className="h-4 w-4" />
                    <CreateLeagueModal league={league} />
                  </CommandItem>
                </CommandGroup>
              )}
            </CommandList>
            <div className="border-t px-3 py-2">
              <p className="text-xs text-muted-foreground text-center">Powered by Staty</p>
            </div>
          </Command>
        </PopoverContent>
      </Popover>
    </div>
  ) : (
    <div className="league-selector-single">
      <div className="league-name">{league?.displayName}</div>
      <Badge variant="secondary" className="league-badge">Active</Badge>
    </div>
  );

  return (
    <>
      <button
        aria-label="Open navigation menu"
        className="nav-mobile-toggle fixed z-30 lg:hidden left-4 top-3 flex items-center justify-center h-10 w-10 bg-card hover:bg-muted/50 active:bg-muted border border-border rounded-lg shadow-sm text-foreground transition-colors"
        onClick={() => setShowSidebar(!showSidebar)}
      >
        <Menu width={20} height={20} />
      </button>
      <div className={cn("nav-sidebar", showSidebar && "nav-sidebar-mobile-open")}>
        <div className="nav-content">
          <div className="nav-header">
            <div className="nav-logo cursor-pointer" onClick={() => navigate('/admin/dashboard')}>
              {/* Bundled asset, not the CDN URL — the remote logo popped in
                  after first paint on every cold load. */}
              <img
                src={Logo}
                width={120}
                height={24}
                alt="Staty Logo"
                className="nav-logo-image"
              />
            </div>
            <button
              className="lg:hidden absolute top-4 right-4 p-2 text-muted-foreground/60 hover:text-muted-foreground"
              onClick={() => setShowSidebar(false)}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>

          <button
            type="button"
            aria-label="Open command palette"
            className="mx-4 mb-2 flex items-center gap-2 rounded-md border border-border bg-muted/50 px-3 py-1.5 text-sm text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
            onClick={() => window.dispatchEvent(new CustomEvent(OPEN_COMMAND_PALETTE_EVENT))}
          >
            <SearchIcon width={14} height={14} />
            <span className="flex-1 text-left">Search…</span>
            <kbd className="rounded border border-border bg-card px-1.5 py-0.5 text-[10px] font-medium text-muted-foreground">⌘K</kbd>
          </button>

          <div className="nav-sections">
            {/* Main Overview Section */}
            <div className="nav-section">
              <button
                className="nav-section-header-button"
                onClick={() => toggleSection('overview')}
              >
                <ChevronRight
                  className={cn(
                    "nav-section-chevron",
                    expandedSections.overview && "nav-section-chevron-expanded"
                  )}
                  width={14}
                  height={14}
                />
                <span>Overview</span>
              </button>
              <div className={cn(
                "nav-links-collapsible",
                expandedSections.overview && "nav-links-expanded"
              )}>
                <div className="nav-links">
                  {mainTabs.map(({ name, href, isActive, icon, disabled, newTab, dataTour }) => (
                    <Link
                      key={name}
                      target={newTab ? "_blank" : "_self"}
                      to={disabled ? '#' : href}
                      data-tour={dataTour}
                      onClick={() => { if (!disabled && !newTab) setShowSidebar(false); }}
                      className={cn(
                        "nav-link",
                        isActive && "nav-link-active",
                        disabled && "nav-link-disabled"
                      )}
                    >
                      <div className="nav-link-icon">{icon}</div>
                      <span className="nav-link-text">{name}</span>
                      {newTab && <span className="nav-link-external">↗</span>}
                    </Link>
                  ))}
                </div>
              </div>
            </div>

            {/* League Management Section */}
            <div className="nav-section">
              <button
                className="nav-section-header-button"
                onClick={() => toggleSection('leagueManagement')}
              >
                <ChevronRight
                  className={cn(
                    "nav-section-chevron",
                    expandedSections.leagueManagement && "nav-section-chevron-expanded"
                  )}
                  width={14}
                  height={14}
                />
                <span>League Management</span>
              </button>
              <div className={cn(
                "nav-links-collapsible",
                expandedSections.leagueManagement && "nav-links-expanded"
              )}>
                <div className="nav-links">
                  {leagueManagementTabs.map(({ name, href, isActive, icon, dataTour }) => (
                    <Link
                      key={name}
                      to={href}
                      data-tour={dataTour}
                      onClick={() => setShowSidebar(false)}
                      className={cn(
                        "nav-link",
                        isActive && "nav-link-active"
                      )}
                    >
                      <div className="nav-link-icon">{icon}</div>
                      <span className="nav-link-text">{name}</span>
                    </Link>
                  ))}
                </div>
              </div>
            </div>

            {/* Registration & Teams Section */}
            <div className="nav-section">
              <button
                className="nav-section-header-button"
                onClick={() => toggleSection('registration')}
              >
                <ChevronRight
                  className={cn(
                    "nav-section-chevron",
                    expandedSections.registration && "nav-section-chevron-expanded"
                  )}
                  width={14}
                  height={14}
                />
                <span>Registration & Teams</span>
              </button>
              <div className={cn(
                "nav-links-collapsible",
                expandedSections.registration && "nav-links-expanded"
              )}>
                <div className="nav-links">
                  {registrationTabs.map(({ name, href, isActive, icon, dataTour }) => (
                    <Link
                      key={name}
                      to={href}
                      data-tour={dataTour}
                      onClick={() => setShowSidebar(false)}
                      className={cn(
                        "nav-link",
                        isActive && "nav-link-active"
                      )}
                    >
                      <div className="nav-link-icon">{icon}</div>
                      <span className="nav-link-text">{name}</span>
                    </Link>
                  ))}
                </div>
              </div>
            </div>

            {/* Payments & Activity (records) section — renamed from Financial 2026-09-11 */}
            <div className="nav-section">
              <button
                className="nav-section-header-button"
                onClick={() => toggleSection('financial')}
              >
                <ChevronRight
                  className={cn(
                    "nav-section-chevron",
                    expandedSections.financial && "nav-section-chevron-expanded"
                  )}
                  width={14}
                  height={14}
                />
                <span>Payments & Activity</span>
              </button>
              <div className={cn(
                "nav-links-collapsible",
                expandedSections.financial && "nav-links-expanded"
              )}>
                <div className="nav-links">
                  {financialTabs.map(({ name, href, isActive, icon, dataTour }) => (
                    <Link
                      key={name}
                      to={href}
                      data-tour={dataTour}
                      onClick={() => setShowSidebar(false)}
                      className={cn(
                        "nav-link",
                        isActive && "nav-link-active"
                      )}
                    >
                      <div className="nav-link-icon">{icon}</div>
                      <span className="nav-link-text">{name}</span>
                    </Link>
                  ))}
                </div>
              </div>
            </div>

            {/* System & Tools Section */}
            <div className="nav-section">
              <button
                className="nav-section-header-button"
                onClick={() => toggleSection('system')}
              >
                <ChevronRight
                  className={cn(
                    "nav-section-chevron",
                    expandedSections.system && "nav-section-chevron-expanded"
                  )}
                  width={14}
                  height={14}
                />
                <span>System & Tools</span>
              </button>
              <div className={cn(
                "nav-links-collapsible",
                expandedSections.system && "nav-links-expanded"
              )}>
                <div className="nav-links">
                  {systemTabs.map(({ name, href, isActive, icon, dataTour }) => (
                    <Link
                      key={name}
                      to={href}
                      data-tour={dataTour}
                      onClick={() => setShowSidebar(false)}
                      className={cn(
                        "nav-link",
                        isActive && "nav-link-active"
                      )}
                    >
                      <div className="nav-link-icon">{icon}</div>
                      <span className="nav-link-text">{name}</span>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* <div className="nav-footer">
            {children}
          </div> */}
        </div>
      </div>
    </>
  );
}
